import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft, ShieldCheck, Sparkles, Clock3, CheckCircle2 } from 'lucide-react'
import { BottomNavigator } from '@/components/BottomNavigator'
import { spacing } from '@/theme'
import { api } from '@/api/axios'
import { useEffect, useState } from 'react'

type InteractionModule = {
  key: string
  title: string
  description: string | null
}

export function SegurosScreen() {
  const navigate = useNavigate()
  const [moduleInfo, setModuleInfo] = useState<InteractionModule | null>(null)

  useEffect(() => {
    api.get('/interaction-modules/active').then((res) => {
      const mods: InteractionModule[] = res.data.data || []
      setModuleInfo(mods.find((m) => m.key === 'seguros') || null)
    }).catch(() => {})
  }, [])

  return (
    <>
      <div
        style={{
          minHeight: '100vh',
          padding: spacing[4],
          paddingBottom: '56px',
          background: 'linear-gradient(180deg, #020617 0%, #0f172a 30%, #334155 70%, #0f172a 100%)',
        }}
      >
        <div style={{ maxWidth: 680, margin: '0 auto' }}>
          <button
            onClick={() => navigate('/interacciones')}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: spacing[2],
              color: '#cbd5e1',
              marginBottom: spacing[3],
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: 14,
            }}
          >
            <ArrowLeft size={18} />
            Volver
          </button>

          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            style={{
              borderRadius: 24,
              padding: spacing[5],
              marginBottom: spacing[4],
              background: 'linear-gradient(135deg, rgba(100, 116, 139, 0.15) 0%, rgba(30, 41, 59, 0.4) 100%)',
              border: '1px solid rgba(100, 116, 139, 0.3)',
              backdropFilter: 'blur(10px)',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <div style={{
              position: 'absolute',
              top: -60,
              right: -60,
              width: 160,
              height: 160,
              borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(100, 116, 139, 0.12) 0%, transparent 70%)',
            }} />
            <div style={{ display: 'flex', alignItems: 'center', gap: spacing[3], position: 'relative', zIndex: 1 }}>
              <div style={{
                width: 48,
                height: 48,
                borderRadius: 16,
                background: 'linear-gradient(135deg, #64748b, #334155)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 8px 24px rgba(100, 116, 139, 0.3)',
              }}>
                <ShieldCheck size={24} color="#fff" />
              </div>
              <div>
                <h1 style={{ margin: 0, fontSize: 24, fontWeight: 800, color: '#f1f5f9' }}>{moduleInfo?.title || 'Seguros'}</h1>
                <p style={{ margin: '4px 0 0', fontSize: 13, color: '#94a3b8' }}>
                  {moduleInfo?.description || 'Protege tu vehiculo y tu camino'}
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.08 }}
            style={{
              borderRadius: 20,
              padding: spacing[5],
              marginBottom: spacing[3],
              background: 'linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(15, 23, 42, 0.8) 100%)',
              border: '1px solid rgba(100, 116, 139, 0.2)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: spacing[2], marginBottom: spacing[3] }}>
              <Sparkles size={18} color="#94a3b8" />
              <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#f1f5f9' }}>Proximamente</h2>
            </div>
            <p style={{ margin: 0, fontSize: 14, lineHeight: 1.6, color: '#cbd5e1' }}>
              Este modulo se encuentra en preparacion. Pronto encontraras aqui toda la informacion sobre seguros.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: spacing[2], marginTop: spacing[3] }}>
              {['Cobertura de tu vehiculo', 'Tranquilidad en cada viaje', 'Atencion personalizada'].map((item) => (
                <div key={item} style={{ display: 'flex', alignItems: 'center', gap: spacing[2] }}>
                  <CheckCircle2 size={15} color="#94a3b8" />
                  <span style={{ fontSize: 13, color: '#94a3b8' }}>{item}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
      <BottomNavigator />
    </>
  )
}
